/* eslint-disable */
import { useEffect, useRef, useState } from 'react';

// NOTE: This matches Kira-Talk's attributes, which use snake_case (boo)
type CustomerData = {
  name: string;
  email: string;
  company_rank?: string;
  company?: {
    id: string;
    name: string;
    created_at: string;
    company_type: string;
  };
};

const useIntercom = (
  customIdSelector?: string,
  customerData?: CustomerData
) => {
  const [isLoading, setIsLoading] = useState(true);
  const lastCustomerData = useRef<CustomerData>();

  useEffect(() => {
    if (!process.env.REACT_APP_INTERCOM_APP_ID) {
      console.warn('Intercom App ID not specified. Ignoring script injection.');
      return;
    }

    // Copy pasta from Intercom's website. Ignore the any's.
    const w = window;
    const ic = w.Intercom;

    if (!ic) {
      const d = document;
      const i: any = function () {
        i.c(arguments);
      };
      i.q = [];
      i.c = function (args: any) {
        i.q.push(args);
      };
      w.Intercom = i;
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://widget.intercom.io/widget/${process.env.REACT_APP_INTERCOM_APP_ID}`;
      const x = d.getElementsByTagName('script')[0];
      x.parentNode?.insertBefore(s, x);
    }
    // Pasta finished, no excuses now

    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!customIdSelector) {
      return;
    }

    window.intercomSettings = {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      custom_launcher_selector: `#${customIdSelector}`,
      hide_default_launcher: true,
    };

    // Copy pasta from Intercom's website. Ignore the any's.
    const w = window;
    const ic = w.Intercom;

    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
    }
    // Pasta finished, no excuses now
  }, [customIdSelector]);

  useEffect(
    () => () => {
      if (window.Intercom && lastCustomerData.current) {
        window.Intercom('shutdown');
      }
    },
    []
  );

  useEffect(() => {
    if (!window.Intercom || !customerData) {
      return;
    }

    const { Intercom } = window;

    Intercom(lastCustomerData.current ? 'update' : 'boot', customerData);
    lastCustomerData.current = customerData;
  }, [window?.Intercom, JSON.stringify(customerData)]);

  return { isLoading };
};

export default useIntercom;
